const PAGE_TYPES = [
  ['magazine_author', /^\/magazin\/autoren(\/|$)/],
  ['magazine', /^\/magazin(\/|$)/],
  ['jdp', /^\/job-details(\/|$)/],
  ['llp_role_city', /^\/jobs\/[^/]+\/[^/]+(\/|$)/],
  ['llp_role', /^\/jobs\/[^/]+(\/|$)/],
  ['llp_role_legacy', /^\/stellenangebote(\/|$)/],
  ['gehalt_calculator', /^\/gehaltsrechner(\/|$)/],
  ['gehalt', /^\/gehalt(\/|$)/],
  ['regionen_state', /^\/regionen\/[^/]+(\/|$)/],
  ['regionen', /^\/regionen(\/|$)/],
  ['job_board', /^\/job-board(\/|$)/],
  ['employers', /^\/(employers|arbeitgeber|arbeiten-bei-pflegia)(\/|$)/],
  ['funnel', /^\/(login|forgot-password|funnel|finish-registration|fast-track|candidate\/second-step-registration)(\/|$)/],
  [
    'informational',
    /^\/(ueber-pflegia|faqs|contact|imprint-privacy|terms-and-conditions|freunde-programm|presse|presse-mitteilungen|pressespiegel)(\/|$)/,
  ],
  ['homepage', /^(\/|\/de\/?|\/locales\/de\/?)$/],
] as const;

export const getPageType = (pathname: string): (typeof PAGE_TYPES)[number][0] | 'other' =>
  PAGE_TYPES.find(([, pattern]) => pattern.test(pathname.split(/[?#]/)[0]))?.[0] ?? 'other';
